import { AVAILABLE_PAGE_SIZE, DEFAULT_PAGE_SIZE } from '@client/app/shared-modules/api/constants/page-size.constant';
import { DEFAULT_PAGE } from '@client/app/shared-modules/api/constants/page.constant';
import { Transition } from '@uirouter/core';

export const paginationUrlQueryParamsValidator = (stateName: string) => (transition: Transition) => {
    const params = transition.params();
    let { page_size, page } = params;
    page_size = parseInt(page_size);
    page = parseInt(page);
    let shouldRedirect = false;
    if (!AVAILABLE_PAGE_SIZE.includes(page_size)) {
        page_size = DEFAULT_PAGE_SIZE.toString();
        shouldRedirect = true;
    }
    if (isNaN(page) || page < 1) {
        page = DEFAULT_PAGE.toString();
        shouldRedirect = true;
    }

    if (shouldRedirect) {
        return {
            state: stateName,
            params: {
                ...transition.params(),
                page_size,
                page,
            },
        };
    }
    return undefined;
};
